import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { api } from '../properties/endpoints';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getAllUsers() {
    // const api = '../../assets/mock/all_materials.json';
    const url = `${api.host}/user/all`;
    return this.http.get(url);
  }
  getNextUsers(pages) {
    const url = `${api.host}/user/all` + `?${pages}`;
    return this.http.get(url);
  }
  getUserForm() {
    // const api = '../../assets/mock/allMetaData.json';
    const url = `${api.host}/user/metadata`;
    return this.http.get(url);
  }
  getUserById(userId) {
    // const api = '../../assets/mock/getMaterialByCode.json';
    const url = `${api.host}/user/${userId}`;
    return this.http.get(url);
  }
  getUserAttributes(userId) {
    const url = `${api.host}/user/${userId}/attributes`;

    return this.http.get(url);
  }

  getMarketplace(){
    const url=`${api.host}/marketplace/all`
    return this.http.get(url);
  }
  sendOptionReq(){
    const url=`${api.host}/marketplace/all`
    return this.http.options(url);
  }
  resetPassword(email) {
    const url = `${api.host}/user/password/reset`;
    return this.http.post<any>(url, email)
  }

  changepasswd(userId,OldPassword,newPassword){
    const url = `${api.host}/user/password/change`;
    const data={
      userId:userId,
      oldPassword:OldPassword,
      newPassword:newPassword
    }
    return this.http.post<any>(url,data)
  }

  saveUser(formValues, formData, addFlag, id,changed): Observable<any[]> {
    const userCreateApi = `${api.host}/user/create`;
    const userUpdateApi = `${api.host}/user/update?pwdChange=${changed}`;
    const userAttributeSaveApi = `${api.host}/user/update/attributes`;
    const resultJson = {};
    const resultJsonAttributes = [];
    resultJson['id'] = id;
    console.log('formData',formData)
    console.log('formValues',formValues)
    formData.map((eachFormData) => {
      if (eachFormData.dynamic) {
        const attributeId = addFlag ? null : eachFormData.id;
        resultJsonAttributes.push({
          'id': attributeId,
          'userId': formValues['userId'].value,
          'attributeName': eachFormData.identifier,
          'attributeValue': formValues[eachFormData.identifier].value
        });
        console.log('resultJson6',resultJsonAttributes)
      
      } else {
        resultJson[eachFormData.identifier] = formValues[eachFormData.identifier].value;
        
        if (eachFormData.dataType === "Array") {
          resultJson[eachFormData.identifier] = formValues[eachFormData.identifier].value && formValues[eachFormData.identifier].value instanceof Array ? formValues[eachFormData.identifier].value : formValues[eachFormData.identifier].value.split(',');
        }
        console.log('resultJson',resultJson)
      }
    });

    return forkJoin([addFlag ? this.http.put<any>(userCreateApi, resultJson) : this.http.post<any>(userUpdateApi, resultJson), this.http.post<any>(userAttributeSaveApi, resultJsonAttributes)]);
  }
  // deleteUser(id: string) {
  //   const url = `${api.host}/user/${id}`;
  //   return this.http.delete(url);
  // }
  deleteUser(id: string): Observable<any[]> {
    const userDeleteApi = `${api.host}/user/${id}`;
    const userAttributeDeleteApi = `${api.host}/user/update/attributes`;
  
    const attributeDeletePayload = []; // Empty array or pass specific attributes if needed
  
    return forkJoin([
      this.http.delete(userDeleteApi,{responseType: 'text' }),
      this.http.post<any>(userAttributeDeleteApi, attributeDeletePayload)
    ]);
  }

}
